export class FetchRaceByIdRequest {
  constructor(public raceId?: number, public page?: number) {
  };
}